export default __webpack_public_path__ + "static/media/6.cf840819.jpeg";